<template>
  <validation-observer ref="form">
    <b-form @submit.prevent>
      <b-row>
        <!-- Nome -->
        <b-col
          cols="12"
          md="8"
        >
          <validation-provider
            #default="{ errors }"
            name="nome"
            rules="required"
          >
            <b-form-group
              label="Nome do Evento"
              label-for="v-name"
            >
              <b-form-input
                id="v-name"
                v-model="form.nome"
                :state="errors.length > 0 ? false : null"
                placeholder="Ex: Retiro Espiritual 2024"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Tipo de Evento -->
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="{ errors }"
            name="Tipo Evento"
            rules="required"
          >
            <b-form-group
              label="Tipo de Evento"
              label-for="v-tipo"
            >
              <v-select
                v-model="form.tipoEvento.id"
                :reduce="item => item.id"
                label="nome"
                :options="comboTipoEvento"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Descrição -->
        <b-col cols="12">
          <b-form-group
            label="Descrição Detalhada"
            label-for="v-desc"
          >
            <b-form-textarea
              id="v-desc"
              v-model="form.descricao"
              rows="3"
              placeholder="Detalhes sobre o evento..."
            />
          </b-form-group>
        </b-col>

        <!-- Local -->
        <b-col cols="12">
          <b-form-group
            label="Local / Endereço"
            label-for="v-local"
          >
            <b-form-input
              id="v-local"
              v-model="form.local"
              placeholder="Ex: Centro de Convenções Syper"
            />
          </b-form-group>
        </b-col>

        <!-- Datas -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group label="Data Inicial">
            <flat-pickr
              v-model="form.dataInicial"
              class="form-control"
              :config="{ altInput: true, altFormat: 'd/m/Y', dateFormat: 'Y-m-d' }"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group label="Data Final">
            <flat-pickr
              v-model="form.dataFinal"
              class="form-control"
              :config="{ altInput: true, altFormat: 'd/m/Y', dateFormat: 'Y-m-d' }"
            />
          </b-form-group>
        </b-col>

        <!-- Horas -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group label="Hora Início">
            <flat-pickr
              v-model="form.hora"
              class="form-control"
              :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true }"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group label="Hora Fim">
            <flat-pickr
              v-model="form.horaFinal"
              class="form-control"
              :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true }"
            />
          </b-form-group>
        </b-col>

        <!-- Vagas e Público -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group label="Qtd. Vagas">
            <b-form-input
              v-model="form.qtoVaga"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="Público Alvo">
            <b-form-input
              v-model="form.publicoAlvo"
              placeholder="Ex: Jovens, Casais..."
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group label="Status">
            <v-select
              v-model="form.status"
              :reduce="i => i.value"
              label="label"
              :options="comboStatus"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="mt-2 border-top pt-2 text-right"
        >
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="$emit('cancel')"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            @click="$emit('save')"
          >
            Salvar Evento
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BButton, BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { mapState } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
  },
  props: ['form', 'isEdit'],
  data() {
    return {
      required,
      comboStatus: [
        { value: 'PLANEJADO', label: 'Planejado' },
        { value: 'ACONTECENDO', label: 'Acontecendo' },
        { value: 'FINALIZADO', label: 'Finalizado' },
        { value: 'CANCELADO', label: 'Cancelado' },
      ],
    }
  },
  computed: {
    ...mapState('combosModule', ['comboTipoEvento']),
  },
  mounted() {
    this.$store.dispatch('combosModule/loadComboTipoEvento')
  },
}
</script>
